import { render, staticRenderFns } from "./ProjectDocumentEditFrProject.vue?vue&type=template&id=2210bbc0&"
import script from "./ProjectDocumentEditFrProject.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentEditFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports